export class HeaderDesktop {
	element = document.querySelector('.header-desktop');
	elementHeight = this.element?.offsetHeight;
	fixed = false;
	fixedClass = 'header-desktop--fixed';

	constructor() {
		if (this.element) this.init();
	}

	fix = () => {
		this.element.classList.add(this.fixedClass);
		this.fixed = true;
	};

	unfix = () => {
		this.element.classList.remove(this.fixedClass);
		this.fixed = false;
	};

	windowScrollHandler = () => {
		if (window.scrollY >= this.elementHeight && !this.fixed) this.fix();
		else if (window.scrollY < this.elementHeight && this.fixed) this.unfix();
	};

	init = () => {
		window.addEventListener('scroll', this.windowScrollHandler);
	};
}
